import { AnyAction } from 'redux';
import { Store } from 'store';
import { ThunkDispatch } from 'redux-thunk';
import getCategoryId from 'store/category/selector/getCategoryId';
import getProductItem from 'store/product/selector/getProductItem';
import getLanguagePrefix from 'store/app/selector/getLanguagePrefix';
import getOpRoute from '../selector/getOpRoute';

const redirectToCartOperation = () => (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
  const store = getState();
  // const route = getOpRoute(store, AppBundle.Api.Response.App.V1.RoutingListV1Response.Route.RouteType.BASKET);
  const route = getOpRoute(store, 1);
  const categoryId = getCategoryId(store);
  const productTypeId = getProductItem(store)?.product.productTypeId;
  const langPrefix = getLanguagePrefix(store);

  if (!route?.path) return;

  const query = new URLSearchParams();
  if (categoryId) {
    query.append('categoryId', categoryId.toString());
  }
  if (productTypeId) {
    query.append('productTypeId', productTypeId.toString());
  }

  window.location.href = `${langPrefix}${route?.path}?${query.toString()}`;
};

export default redirectToCartOperation;
